import { Container } from "@mui/material";
import MisCertificados from "../../componentes/Certificados/MisCertificados";

export const CertificadosPage:React.FC<{}> =() =>{
    return(
        <Container sx={{mt:4}}>
            <MisCertificados />
        </Container>
        
    );
}